import {TextButton} from '../../index'

const SubmitButton = ({className, onClick}) => {
    return (
        <TextButton className={className} clickHandler={onClick}>Submit</TextButton>
    )
}

export default SubmitButton